<template>
    <div class="page_cjz flex-col">
        <div class="group_176 flex-col">
            <div class="group_9 flex-col">
                <div class="text-group_351 flex-col justify-between">
                    <span class="text_16">我们的价值观</span>
                    <span class="text_17">OUR&nbsp;VALUES</span>
                </div>

                <div class="grid_3">
                    <div class="group_10 flex-col"
                         :class="{ 'hover-shadow': isHovered }"
                         :style="{ '--dynamic-bg10': 'url(' + backgroundImages.group_10 + ')' }"><div class="section_1 flex-col"></div></div>
                    <div class="group_11 flex-col" :style="{ '--dynamic-bg11': 'url(' + backgroundImages.group_11 + ')' }"><div class="block_1 flex-col"></div></div>

                    <div class="group_16 flex-col"
                         :class="{ 'hover-shadow': isHovered }"
                         @mouseenter="isHovered = true"
                         @mouseleave="isHovered = false"
                    >
                        <div class="group_18 flex-col">
                            <div class="text-group_352 flex-col justify-between">
                                <span class="text_18">担当</span>
                                <span class="text_19">Commitment</span>
                            </div>
                            <img
                                    class="image_4"
                                    referrerpolicy="no-referrer"
                                    src="../../assets/home/home_line_01.png"
                            />
                            <span class="text_20">恪守承诺，全力以赴</span>
                        </div>
                    </div>
                    <div class="group_17 flex-col"  :class="{ 'hover-shadow': isHovered2 }"
                         @mouseenter="isHovered2 = true"
                         @mouseleave="isHovered2 = false">
                        <div class="group_18 flex-col">
                            <div class="text-group_353 flex-col justify-between">
                                <span class="text_21">诚信</span>
                                <span class="text_22">Honesty</span>
                            </div>
                            <img
                                    class="image_5"
                                    referrerpolicy="no-referrer"
                                    src="../../assets/home/home_line_02.png"
                            />
                            <span class="text_23">求真务实，客观公正</span>
                        </div>
                    </div>
                </div>

                <div class="grid_3 flex-row">
                    <div class="group_12 flex-col" :style="{ '--dynamic-bg12': 'url(' + backgroundImages.group_12 + ')' }"><div class="group_13 flex-col"></div></div>
                    <div class="group_14 flex-col" :style="{ '--dynamic-bg14': 'url(' + backgroundImages.group_14 + ')' }"><div class="group_15 flex-col"></div></div>
                    <div class="group_19 flex-col" :class="{ 'hover-shadow': isHovered3 }"
                         @mouseenter="isHovered3 = true"
                         @mouseleave="isHovered3 = false" >
                        <div class="group_20 flex-col">
                            <div class="text-group_354 flex-col justify-between">
                                <span class="text_24">专业</span>
                                <span class="text_25">Profession</span>
                            </div>
                            <img
                                    class="image_6"
                                    referrerpolicy="no-referrer"
                                    src="../../assets/home/home_line_03.png"
                            />
                            <span class="text_26">精进创新，追求卓越</span>
                        </div>
                    </div>
                    <div class="group_21 flex-col" :class="{ 'hover-shadow': isHovered4 }"
                         @mouseenter="isHovered4 = true"
                         @mouseleave="isHovered4 = false" >
                        <div class="box_11 flex-col">
                            <div class="text-group_355 flex-col justify-between">
                                <span class="text_27">合作</span>
                                <span class="text_28">Cooperation</span>
                            </div>
                            <img
                                    class="image_7"
                                    referrerpolicy="no-referrer"
                                    src="../../assets/home/home_line_04.png"
                            />
                            <span class="text_29">感恩利他，协作共赢</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                backgroundImages: {
                    group_10: require('../../assets/home/home_my_value_01.png'),
                    group_11: require('../../assets/home/home_my_value_02.png'),
                    group_12: require('../../assets/home/home_my_value_03.png'),
                    group_14: require('../../assets/home/home_my_value_04.png'),
                },
                isHovered: false,
                isHovered2: false,
                isHovered3: false,
                isHovered4: false,
            };
        },
        methods: {}
    };
</script>

<style scoped lang="css"  >
    .page_cjz {

    }
    /* 新增flex-row定义 */
    .flex-row {
        display: flex;
        flex-direction: row;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .group_176 {
        max-width: 1200px;
        min-height: 609px;
        height: auto;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .group_9 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 6px;
        width: 100%;

        height: auto;
        margin-bottom: 1px;
    }
    .text-group_351 {
        width: 228px;
        height: 89px;

        margin: 48px auto 0;
        text-align: center;
    }

    .text_16 {
        width: 228px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_17 {
        width: 166px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: center;
        white-space: nowrap;
        line-height: 31px;
        margin: 6px 0 0 31px;
    }

    .grid_3 {
        display: grid;
        grid-template-columns: repeat(2, 291px);
        gap: 12px;
        max-width: 1200px;
        height: 376px;

        margin: 44px auto 52px;
        justify-content: center;
    }

    .group_10 {
        border-radius: 8px 8px 0px 0px;
        height: 163px;
        margin-right: 12px;
        width: 291px;

        box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.05);
    }

    .group_10:nth-child(4n) {
        margin-right: 0;
    }
    .group_10:nth-last-child(-n + 4) {
        margin-bottom: 0;
    }

    .section_1 {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 8px 8px 0px 0px;
        width: 291px;
        height: 163px;
    }

    .group_11 {
        cursor: pointer;
        border-radius: 8px 8px 0px 0px;
        height: 163px;
        margin-right: 12px;
        width: 291px;
    }

    .block_1 {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 8px 8px 0px 0px;
        width: 291px;
        height: 163px;
    }

    .group_13 {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 8px 8px 0px 0px;
        width: 291px;
        height: 163px;
    }

    .group_15 {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 8px 8px 0px 0px;
        width: 291px;
        height: 163px;
    }

    /* 统一设置子元素样式 */
    .group_12 .group_13,
    .group_14 .group_15,
    .group_16 .box_10 {
        transition: transform 0.3s;
        transform-origin: center center;
        width: 100%;
        height: 100%;
    }

    /* 保持原有布局结构 */
    .group_12 {
        cursor: pointer;
        border-radius: 8px 8px 0px 0px;
        height: 163px;
        margin-right: 12px;
        width: 291px;
    }

    .group_14 {
        border-radius: 8px 8px 0px 0px;
        height: 163px;
        width: 291px;
    }
    .group_10.hover-shadow,
    .group_16.hover-shadow {
        box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1) !important;
        transition: box-shadow 0.3s ease-in-out;
    }

    .group_11.hover-shadow,
    .group_17.hover-shadow {
        box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1) !important;
        transition: box-shadow 0.3s ease-in-out;
        border-radius: 0px 0px 6px 6px;
    }
    .group_12.hover-shadow,
    .group_19.hover-shadow {
        box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1) !important;
        transition: box-shadow 0.3s ease-in-out;
        border-radius: 0px 0px 6px 6px;
    }

    .group_14.hover-shadow,
    .group_21.hover-shadow {
        box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1) !important;
        transition: box-shadow 0.3s ease-in-out;
        border-radius: 0px 0px 6px 6px;
    }


    .group_16 {
        cursor: pointer;
        height: 213px;
        width: 291px;
        background: url(../../assets/home/home_my_value_bj01.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-right: 12px;

        background: #FFFFFF;
        box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.05);
        transition: box-shadow 0.3s ease-in-out;

    }

    /* 调整其他需要放大的组 */
    .group_17,
    .group_19,
    .group_21 {
        overflow: hidden;
        position: relative;
    }
    .group_10, .group_11, .group_16, .group_17,
    .group_12, .group_14, .group_19, .group_21 {
        cursor: pointer;
        width: 90%;
        max-width: 291px;
        margin: 10px auto;
    }
    .group_18, .group_20, .box_11 {
        display: flex;
        flex-direction: column;
        align-items: self-start;
        text-align: center;
    }

    /* 调整图片和文字间距 */
    .image_4, .image_5, .image_6, .image_7 {
        margin: 18px auto 0;
    }

    /* 保持原有 hover 效果和其他样式 */
    .group_10.hover-shadow,
    .group_16.hover-shadow {
        box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1) !important;
        transition: box-shadow 0.3s ease-in-out;
        border-radius: 0px 0px 6px 6px;
    }

    .group_17 .group_18,
    .group_19 .group_20,
    .group_21 .box_11 {
        transition: transform 0.3s;
        transform-origin: center center;
    }



    /* 新增的hover效果样式 */
    .group_10,
    .group_11,
    .group_12,
    .group_14,
    .group_16 {
        cursor: pointer;
        overflow: hidden;
        position: relative;
        transition: all 0.3s ease-in-out;
    }

    .group_10::after,
    .group_11::after,
    .group_12::after,
    .group_14::after,
    .group_16::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease-in-out;
    }

    .group_10:hover::after,
    .group_11:hover::after,
    .group_12:hover::after,
    .group_14:hover::after,
    .group_16:hover::after {
        transform: scale(1.2);
    }

    /* 为每个分组添加对应的背景图 */
    .group_10::after {
        background-image: var(--dynamic-bg10);
        background-size: cover;
        background-position: center;
    }
    .group_11::after {
        background-image: var(--dynamic-bg11);
        background-size: cover;
        background-position: center;
    }

    .group_12::after {
        background-image: var(--dynamic-bg12);
        background-size: cover;
        background-position: center;
    }

    .group_14::after {
        background-image: var(--dynamic-bg14);
        background-size: cover;
        background-position: center;
    }

    /* 调整原有样式保证内容显示 */
    .group_10 .section_1,
    .group_11 .block_1,
    .group_12 .group_13,
    .group_14 .group_15,
    .group_16 .box_10 {
        position: relative;
        z-index: 2;
        background: transparent !important;
    }
    /**end**/
    .text-group_352 {
        width: 130px;
        height: 62px;
        margin: 35px 0 0 23px;
    }

    .text_18 {
        width: 48px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(31, 35, 41, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text_19 {
        width: 135px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin-top: -1px;
        opacity: 0.4;
    }

    .image_4 {
        width: 234px;
        height: 1px;
        margin: 18px 0 0 23px;
    }

    .text_20 {
        width: 162px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin: 18px 0 54px 23px;
    }

    .group_17 {
        cursor: pointer;
        height: 213px;
        width: 291px;
        background: url(../../assets/home/home_my_value_bj01.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-right: 12px;

        background: #FFFFFF;
        box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.05);
    }

    .group_18 {
        cursor: pointer;
        width: 291px;
        height: 213px;
        border-radius: 0px 0px 6px 6px;
    }
    .group_10,
    .group_11,
    .group_12,
    .group_14,
    .group_16,
    .group_17,
    .group_19,
    .group_21 {
        cursor: pointer;
        border-radius: 0px 0px 6px 6px;
        overflow: hidden;
    }
    .text-group_353 {
        width: 130px;
        height: 62px;
        margin: 35px 0 0 23px;
    }

    .text_21 {
        width: 48px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(31, 35, 41, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text_22 {
        width: 86px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin-top: -1px;
        opacity: 0.4;
    }

    .image_5 {
        width: 234px;
        height: 1px;
        margin: 18px 0 0 23px;
    }

    .text_23 {
        width: 162px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin: 18px 0 54px 23px;
    }

    .group_19 {
        cursor: pointer;
        height: 213px;
        width: 291px;
        background: url(../../assets/home/home_my_value_bj01.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-right: 12px;

        background: #FFFFFF;
        box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.05);

    }

    .group_20 {
        cursor: pointer;
        width: 291px;
        height: 213px;
        background: url(../../assets/home/home_my_value_bj02.png) -6px -2px no-repeat;
        background-size: 303px 225px;
    }

    .text-group_354 {
        width: 130px;
        height: 62px;
        margin: 35px 0 0 23px;
    }

    .text_24 {
        width: 48px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(31, 35, 41, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text_25 {
        width: 112px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin-top: -1px;
        opacity: 0.4;
    }

    .image_6 {
        width: 234px;
        height: 1px;
        margin: 18px 0 0 23px;
    }

    .text_26 {
        width: 162px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin: 18px 0 54px 23px;
    }

    .group_21 {
        height: 213px;
        width: 291px;
        background: url(../../assets/home/home_my_value_bj01.png) 100% no-repeat;
        background-size: 100% 100%;

        background: #FFFFFF;
        box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.05);
    }

    .box_11 {
        width: 291px;
        height: 213px;
        background: url(../../assets/home/home_my_value_bj02.png) -6px -2px no-repeat;
        background-size: 303px 225px;
    }

    .text-group_355 {
        width: 130px;
        height: 62px;
        margin: 35px 0 0 23px;
    }

    .text_27 {
        width: 48px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(31, 35, 41, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text_28 {
        width: 130px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin-top: -1px;
        opacity: 0.4;
    }

    .image_7 {
        width: 234px;
        height: 1px;
        margin: 18px 0 0 23px;
    }

    .text_29 {
        width: 162px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 18px;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin: 18px 0 54px 23px;
    }


    /* 超小屏幕手机样式 (0-480px) */
    @media (max-width: 480px) {
        .group_176 {
            padding: 0 10px;
            min-height: auto;
        }

        .group_9 {
            border-radius: 4px;
        }

        .text-group_351 {
            margin: 24px auto 0;
            height: auto;
        }

        .text_16 {
            font-size: 25px;
            line-height: 40px;
        }

        .text_17 {
            font-size: 15px;
            line-height: 24px;
            margin: -15px 0 0 31px;
        }

        .grid_3 {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
            margin: 20px auto 30px;
            height: auto;
        }

        /* 统一调整所有卡片样式 */
        .group_10,
        .group_11,
        .group_12,
        .group_14,
        .group_16,
        .group_17,
        .group_19,
        .group_21 {
            width: 100%;
            height: auto;
            margin: 0;
            border-radius: 4px;
        }

        /* 图片卡片调整 */
        .group_10,
        .group_11,
        .group_12,
        .group_14 {
            height: 120px;
        }

        .section_1,
        .block_1,
        .group_13,
        .group_15 {
            height: 120px;
            border-radius: 4px 4px 0 0;
        }

        /* 文字卡片调整 */
        .group_16,
        .group_17,
        .group_19,
        .group_21 {
            height: 160px;
        }

        .group_18,
        .group_20,
        .box_11 {
            height: 160px;
            padding: 15px 0;
        }

        /* 文字组调整 */
        .text-group_352,
        .text-group_353,
        .text-group_354,
        .text-group_355 {
            margin: 15px 0 0 15px;
            height: auto;
            width: 100%;
        }

        /* 主标题调整 */
        .text_18,
        .text_21,
        .text_24,
        .text_27 {
            font-size: 18px;
            line-height: 24px;
        }

        /* 英文副标题调整 */
        .text_19,
        .text_22,
        .text_25,
        .text_28 {
            font-size: 16px;
            line-height: 20px;
            margin-top: 2px;
        }

        /* 分割线调整 */
        .image_4,
        .image_5,
        .image_6,
        .image_7 {
            width: 80%;
            margin: 10px auto 0;
        }

        /* 描述文字调整 */
        .text_20,
        .text_23,
        .text_26,
        .text_29 {
            font-size: 14px;
            line-height: 18px;
            margin: 10px 0 20px 15px;
            width: 90%;
        }

        /* 阴影效果调整 */
        .group_10.hover-shadow,
        .group_11.hover-shadow,
        .group_12.hover-shadow,
        .group_14.hover-shadow,
        .group_16.hover-shadow,
        .group_17.hover-shadow,
        .group_19.hover-shadow,
        .group_21.hover-shadow {
            box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1) !important;
        }
    }

    /* 小屏幕手机样式 (481px-600px) */
    @media (min-width: 481px) and (max-width: 600px) {
        .group_176 {
            padding: 0 10px;
            min-height: auto;
        }

        .group_9 {
            border-radius: 4px;
        }

        .text-group_351 {
            margin: 24px auto 0;
            height: auto;
        }

        .text_16 {
            font-size: 28px;
            line-height: 40px;
        }

        .text_17 {
            font-size: 18px;
            line-height: 24px;
            margin: 4px 0 0 31px;
        }

        .grid_3 {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
            margin: 20px auto 30px;
            height: auto;
        }

        /* 统一调整所有卡片样式 */
        .group_10,
        .group_11,
        .group_12,
        .group_14,
        .group_16,
        .group_17,
        .group_19,
        .group_21 {
            width: 100%;
            height: auto;
            margin: 0;
            border-radius: 4px;
        }

        /* 图片卡片调整 */
        .group_10,
        .group_11,
        .group_12,
        .group_14 {
            height: 120px;
        }

        .section_1,
        .block_1,
        .group_13,
        .group_15 {
            height: 120px;
            border-radius: 4px 4px 0 0;
        }

        /* 文字卡片调整 */
        .group_16,
        .group_17,
        .group_19,
        .group_21 {
            height: 160px;
        }

        .group_18,
        .group_20,
        .box_11 {
            height: 160px;
            padding: 15px 0;
        }

        /* 文字组调整 */
        .text-group_352,
        .text-group_353,
        .text-group_354,
        .text-group_355 {
            margin: 15px 0 0 15px;
            height: auto;
            width: 100%;
        }

        /* 主标题调整 */
        .text_18,
        .text_21,
        .text_24,
        .text_27 {
            font-size: 18px;
            line-height: 24px;
        }

        /* 英文副标题调整 */
        .text_19,
        .text_22,
        .text_25,
        .text_28 {
            font-size: 16px;
            line-height: 20px;
            margin-top: 2px;
        }

        /* 分割线调整 */
        .image_4,
        .image_5,
        .image_6,
        .image_7 {
            width: 80%;
            margin: 10px auto 0;
        }

        /* 描述文字调整 */
        .text_20,
        .text_23,
        .text_26,
        .text_29 {
            font-size: 14px;
            line-height: 18px;
            margin: 10px 0 20px 15px;
            width: 90%;
        }

        /* 阴影效果调整 */
        .group_10.hover-shadow,
        .group_11.hover-shadow,
        .group_12.hover-shadow,
        .group_14.hover-shadow,
        .group_16.hover-shadow,
        .group_17.hover-shadow,
        .group_19.hover-shadow,
        .group_21.hover-shadow {
            box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1) !important;
        }
    }



</style>
